import './PoliticaDePrivacidade.css';

const PoliticaDePrivacidade = () => {
  const handleBack = () => {
    // Lógica para voltar à página anterior
    window.history.back();
  };

  return (
    <div className="privacy-policy-web">
      <div className="header">
        <div className="logos">
          <img src="/Logo.png" alt="Brasil Papaya Logo" className="logo" />
        </div>
        <h1 className="welcome-text">Política de Privacidade</h1>
        <p className="info-text">Atualizado em 26/08/2025</p>
      </div>

      <div className="content">
        <h2 className="welcome-text">Bem vindo ao Brasil Papaya App Music</h2>
        
        <p>Levamos a sua privacidade a sério e queremos que você entenda como tratamos suas informações. Este app, desenvolvido com o apoio do Governo de Santa Catarina e da banda Papaya, coleta e usa dados dos usuários para proporcionar uma experiência segura e personalizada.</p>
        
        <p><strong>1. Informações Coletadas</strong> Para criar sua conta e acessar os recursos do app, coletamos algumas informações pessoais, incluindo:</p>
        
        <p><strong>CPF:</strong> necessário para autenticação e segurança.</p>
        
        <p><strong>E-mail e senha:</strong> para registro e acesso à sua conta.</p>
        
        <p>Essas informações são coletadas de forma segura e armazenadas com o máximo cuidado para proteger sua privacidade.</p>
        
        <p><strong>2. Uso das Informações</strong> Usamos seus dados apenas para:</p>
        
        <p>Garantir uma experiência personalizada no app.</p>
        
        <p>Proporcionar um ambiente seguro e verificar a autenticidade do usuário.</p>
        
        <p>Enviar notificações sobre atualizações do app, eventos e shows (caso permitido).</p>
        
        <p><strong>3. Compartilhamento de Dados</strong> Suas informações são confidenciais e não serão compartilhadas com terceiros, exceto em caso de exigências legais ou para proteger os direitos do usuário e do próprio app.</p>
        
        <p><strong>4. Segurança dos Dados</strong> Implementamos medidas técnicas e administrativas rigorosas para proteger suas informações contra acessos não autorizados, perda ou alteração.</p>
        
        <p><strong>5. Armazenamento de Dados</strong> Os dados são armazenados de forma segura enquanto você tiver uma conta ativa no Papaya. Em caso de exclusão de conta, seus dados serão removidos dos nossos sistemas conforme as regulamentações vigentes.</p>
        
        <p><strong>6. Direitos dos Usuários</strong> Você tem o direito de acessar, corrigir ou excluir suas informações pessoais. Caso deseje, entre em contato conosco para quaisquer ajustes ou para solicitar a exclusão dos seus dados.</p>
        
        <p><strong>7. Alterações na Política</strong> Poderemos atualizar esta política periodicamente, e incentivamos você a revisar as atualizações. Notificaremos qualquer mudança significativa pelo app ou e-mail.</p>
        
        <p><strong>8. Permissões do Aplicativo</strong></p>
        
        <p>O Brasil Papaya App Music solicita as seguintes permissões para funcionar corretamente:</p>
        
        <p><strong>- Microfone:</strong> Utilizamos o microfone do seu dispositivo para detectar notas musicais e afinar instrumentos em tempo real. Nenhuma gravação de áudio é salva ou compartilhada.</p>
        
        <p><strong>9. Proteção de Dados</strong></p>
        
        <p>Todos os dados são criptografados durante a transmissão (via HTTPS) e armazenados com protocolos de segurança avançados para garantir a proteção e confidencialidade das suas informações.</p>
        
        <p><strong>10. Privacidade Infantil</strong></p>
        
        <p>Este aplicativo não é destinado a menores de 13 anos. Não coletamos intencionalmente dados pessoais de crianças. Caso identifiquemos qualquer coleta não intencional, os dados serão removidos imediatamente.</p>
      </div>

      <div className="logos">
        <img src="/Logo.png" alt="Brasil Papaya Logo" className="logo" />
        <img src="/Gov.png" alt="Governo de Santa Catarina" className="logo" />
      </div>

      <button className="back-button" onClick={handleBack}>
        Voltar
      </button>
    </div>
  );
};

export default PoliticaDePrivacidade;